<template lang="html">

    <article class="oferta-el">

        <div class="top row-between">

            <h3 class="empresa">{{data.empresa}}</h3>

            <div class="tips row-end">
                <h3 class="fecha">{{data.fecha}}</h3>
                <h3 v-if="!!data.provincia" class="localizacion">{{data.provincia}}</h3>
            </div>
            
        </div>

        <div class="middle row-between">

            <h2 class="titulo">{{data.titulo}}</h2>

            <h3 class="estado"  :data="data.estado">{{data.estado}}</h3>


        </div>


    </article>


</template>

<script lang="js">
    export default {
        name: 'candidatura-el',
        props : ['data']

    }
</script>

<style lang="scss" scoped>
            @media screen and (max-width: 900px){

                .oferta-el{
                    min-height: 0;
                }

                .oferta-el .titulo{
                    width: 100%;
                }

                .oferta-el .estado{
                    margin-top: 0;
                }
            
            .oferta-el .tips{
                width: 100%;
                flex-direction: column;
                align-items: flex-start;
                margin-bottom: 0px;
                h3{
                    margin-top: 0;
                    min-height: 0;
                }
                }
            }

            .oferta-el .top .tips .localizacion{
                margin-top: 0;
            }
    
</style>


// WEBPACK FOOTER //
// src/components/view-parts/home/candidatura-el.vue